import { render, staticRenderFns } from "./KeyResultUpdates.vue?vue&type=template&id=7ec88d36&"
import script from "./KeyResultUpdates.vue?vue&type=script&lang=js&"
export * from "./KeyResultUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports